import React, { PureComponent } from "react";
import PropTypes from 'prop-types';
import cx from "classnames";

import { Image } from "blocks/Image/Image";
import { Rating } from "components/reviews/Rating/Rating";
import { ProsCons } from "components/reviews/ProsCons/ProsCons";

import "./ModelSummary.scss";

export class ModelSummary extends PureComponent {
  static propTypes = {
    imageUrl: PropTypes.string,
    heading: PropTypes.string.isRequired,
    description: PropTypes.string,
    rating: PropTypes.object,
    prosCons: PropTypes.object,   
    reviewsLogoSrc: PropTypes.string,
  }

  renderImage(){
    if(!this.props.imageUrl)
      return null;

    return (
      <div className="model-summary__section">
        <div className="model-summary__image">
          <Image src={this.props.imageUrl} alt={this.props.heading} width={525} />
        </div>
      </div>
    );
  }
  render(){
    const classname = cx(
      "model-summary",
      { "model-summary--no-review": !this.props.rating && !this.props.prosCons },
    );

    return (
      <article className={classname}>
        {this.renderImage()}
        <div className="model-summary__section">
          <div className="model-summary__heading">{this.props.heading}</div>
          <p className="model-summary__description">
            {this.props.description}
          </p>      

          {this.props.reviewsLogoSrc && <Rating  className="model-summary__rating" rating={this.props.rating} ratingMeta={this.props.ratingMeta} ratingLogoSrc={this.props.reviewsLogoSrc}/> } 
       
        </div>    
        {this.props.prosCons && 
          <ProsCons className="model-summary__section model-summary__pros-cons" prosConsHeading={this.props.reviewsProsConsLabel} {...this.props.prosCons} /> 
        }        
      </article>
    );
  }
}